module.exports = __webpack_public_path__ + "img/game6.5c32413b.jpg";